<template><!-- svgo-optimised -->
<svg class="icon icon__video-play" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M31.667 20 8.334 33.334V6.667L31.667 20Z" fill="#fff"/></svg></template>